module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-linked-products"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tab-col col-12"
  }, [(_vm.firstTab) ? _c('div', {
    staticClass: "tab-wrap"
  }, [_c('ul', {
    staticClass: "tab-list"
  }, _vm._l((_vm.firstTab.groups), function(group, g_index) {
    return _c('li', {
      key: g_index,
      staticClass: "group-list"
    }, [_c('span', {
      staticClass: "group-title"
    }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('ul', {
      staticClass: "item-list"
    }, _vm._l((group.items), function(item, i_index) {
      return _c('li', {
        key: i_index,
        staticClass: "item"
      }, [_c('b-form-checkbox', {
        staticClass: "checkbox",
        attrs: {
          "checked": [_vm.itemValues[((_vm.firstTab.key) + "-" + (item.id))]],
          "value": true,
          "unchecked-value": false
        },
        on: {
          "change": function($event) {
            _vm.handleItemChange(_vm.firstTab.key, group.key, item, $event)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t")])], 1)
    }))])
  }))]) : _c('div', [_vm._v("\n\t\t\t\tKeine Produkte zur Auswahl\n\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d8b61e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/LinkedProducts.vue
// module id = 645
// module chunks = 0